import React, { useState, useEffect } from 'react';
import { IUser, UserServices } from '../../services/api/users/UserServices';
import { Autocomplete, TextField } from '@mui/material';

interface VAutoCompletEmployerProps {
    uuidCompany: string;
    onUserChange: (selectUser: string) => void;
    error: boolean;
    value?: string;
    required?: boolean;
}

export const VAutoCompletEmployer: React.FC<VAutoCompletEmployerProps> = ({ uuidCompany, onUserChange, error, value, required }) => {
    const [data, setData] = useState<IUser[]>([]);
    const [selectedOption, setSelectedOption] = useState<IUser | null>(null);

    const label = required? 'Usuário *' : 'Usuário';

    useEffect(() => {
        if (uuidCompany) {
            UserServices.get(uuidCompany)
                .then((data) => {                    
                    if (Array.isArray(data)) {
                        setData(data);
                        if (value) {
                            const selectedUser = data.find(user => user.uuid === value) || null;
                            setSelectedOption(selectedUser);
                        }
                    } else {
                        return 'Dados retornados pelo serviço não são um array.';
                    }
                })
                .catch((error) => {
                    return error;
                });
        }
    }, [uuidCompany, value]); 
    const handleOptionChange = (option: IUser | null) => {
        setSelectedOption(option);
        if (option && option.uuid) {
            onUserChange(option.uuid);
        }
    };

    return (
        <div>
            {data.length > 0 && (
                <Autocomplete
                    options={data}
                    getOptionLabel={(option) => option.nome}
                    value={selectedOption} 
                    onChange={(_event, newValue) => handleOptionChange(newValue)}
                    renderInput={(params) => <TextField {...params} label={label} variant="outlined" error={error} />}
                />
            )}
        </div>
    );
};